import React, { useState } from 'react';

import { Impersonate, useCurrentUser } from 'Auth';
import { NotificationsSettings } from 'components/NotificationsSettings';

import { SidePage, Typography, Stack } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { LEFT_DRAWER_Z_INDEX } from '../Sidebar/constants';
import UserMenuList from './UserMenuList';

export const UserMenu = ({ open, onClose, onExited }) => {
  const [childComponent, showChildComponent] = useChildComponent();
  const { name, userPosition } = useCurrentUser();
  const [isOpenImpersonate, setIsOpenImpersonate] = useState(null);

  const handleOpenImpersonate = () => setIsOpenImpersonate(true);
  const handleCloseImpersonate = () => setIsOpenImpersonate(false);

  const handleOpenNotificationsSettings = () =>
    showChildComponent(NotificationsSettings);

  return (
    <SidePage
      open={open}
      onClose={onClose}
      onExited={onExited}
      size={'xs'}
      backdrop={false}
      direction={'right'}
      directionOfset={'64px'}
      zIndex={LEFT_DRAWER_Z_INDEX}
    >
      <SidePage.Title
        onClose={isOpenImpersonate ? handleCloseImpersonate : onClose}
      >
        <Stack>
          {isOpenImpersonate ? (
            <>
              <Typography variant={'h6'}>Impersonating</Typography>
            </>
          ) : (
            <>
              <Typography variant={'h6'}>{name}</Typography>
              <Typography variant={'overline'}>{userPosition}</Typography>
            </>
          )}
        </Stack>
      </SidePage.Title>
      <SidePage.Content disableGutters={true} disableScroll={true}>
        {isOpenImpersonate ? (
          <Impersonate onClose={handleCloseImpersonate} />
        ) : (
          <UserMenuList
            onOpenImpersonate={handleOpenImpersonate}
            onOpenNotificationsSettings={handleOpenNotificationsSettings}
          />
        )}
        {childComponent}
      </SidePage.Content>
    </SidePage>
  );
};
